const SIDEBAR_COLLAPSED_KEY = 'falcon-planner:sidebar-collapsed';
const SIDEBAR_AUTO_COLLAPSE_KEY = 'falcon-planner:sidebar-auto-collapse';
const DASHBOARD_HUB_EXPANDED_KEY = 'falcon-planner:dashboard-hub-expanded';
const REPORTS_HUB_EXPANDED_KEY = 'falcon-planner:reports-hub-expanded';
const SCHEDULE_HUB_EXPANDED_KEY = 'falcon-planner:schedule-hub-expanded';

/** Dispatched when auto-collapse preference changes (AppLayout listens). */
export const SIDEBAR_AUTO_COLLAPSE_CHANGED_EVENT = 'falcon-planner:sidebar-auto-collapse-changed';

function readBool(key: string, defaultValue: boolean): boolean {
  if (typeof window === 'undefined') return defaultValue;
  const raw = localStorage.getItem(key);
  if (raw === null) return defaultValue;
  return raw === 'true';
}

function writeBool(key: string, value: boolean): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(key, String(value));
}

export function getSidebarCollapsed(): boolean {
  return readBool(SIDEBAR_COLLAPSED_KEY, false);
}

export function setSidebarCollapsed(value: boolean): void {
  writeBool(SIDEBAR_COLLAPSED_KEY, value);
}

export function getSidebarAutoCollapse(): boolean {
  return readBool(SIDEBAR_AUTO_COLLAPSE_KEY, false);
}

export function setSidebarAutoCollapse(value: boolean): void {
  writeBool(SIDEBAR_AUTO_COLLAPSE_KEY, value);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SIDEBAR_AUTO_COLLAPSE_CHANGED_EVENT, { detail: { value } }));
  }
}

export function getDashboardHubExpanded(): boolean {
  return readBool(DASHBOARD_HUB_EXPANDED_KEY, true);
}

export function setDashboardHubExpanded(value: boolean): void {
  writeBool(DASHBOARD_HUB_EXPANDED_KEY, value);
}

export function getReportsHubExpanded(): boolean {
  return readBool(REPORTS_HUB_EXPANDED_KEY, true);
}

export function setReportsHubExpanded(value: boolean): void {
  writeBool(REPORTS_HUB_EXPANDED_KEY, value);
}

export function getScheduleHubExpanded(): boolean {
  return readBool(SCHEDULE_HUB_EXPANDED_KEY, true);
}

export function setScheduleHubExpanded(value: boolean): void {
  writeBool(SCHEDULE_HUB_EXPANDED_KEY, value);
}
